<div class="assign-hr-for-business-unit">
  <app-additional-admin-features
    [targetTab]="'HR'"
  ></app-additional-admin-features>
  <div class="row p-l-25 text-normal">
    <div class="col-9 p-0">
      <div class="card p-0 base-shadow-list b-0 fill">
        <div class="card-body">
          <div class="height row">
            <div class="col-4 bu-wrap">
              <div class="assigment-grid">
                <app-treeview
                  [searchable]="true"
                  [dataProvider]="businessUnitDataProvider"
                  (onSelect)="selectBU($event)"
                  scrollHeight="460px"
                >
                  <div another-filter>
                    <input
                      type="checkbox"
                      [formControl]="withoutAdmins"
                      id="testFilter"
                    />
                    <label for="testFilter">Show BUs without HRinBU</label>
                  </div>
                  <ng-template treeview-template let-itemKey="itemKey">
                    <i
                      *ngIf="adminsExists(itemKey)"
                      class="mdi mdi-account-circle admins"
                    ></i>
                  </ng-template>
                </app-treeview>
              </div>
            </div>
            <div class="col-8 hr-wrap">
              <app-spinner
                [ngClass]="{ 'load-process': isLoading }"
                [isEnable]="isSpinnerEnable"
                loaderClass="process-spinner"
              ></app-spinner>
              <div class="body" *ngIf="selectedBU">
                <div class="head m-b-15">
                  Appointment of an HR manager for
                  <span class="font-weight-bold">{{ selectedBU.name }}</span>
                </div>
                <div class="row select-row">
                  <div class="col-6 business-unit-administrators">
                    <div class="hr-select">
                      <div class="mb-1 choose-title">Choose HR:</div>
                      <ngx-select
                        [items]="adminsFilterOptions"
                        [multiple]="false"
                        optionValueField="id"
                        optionTextField="name"
                        (select)="assignBusinessUnitAdministrator($event)"
                        (removed)="unAssignBusinessUnitAdministrator($event)"
                        (typed)="searchBusinessUnitAdministratorByName($event)"
                        placeholder="Enter name"
                      ></ngx-select>
                    </div>
                    <span
                      class="list-element"
                      *ngFor="let buAdmin of selectedBUAdmins"
                    >
                      <span class="list-element-title"
                        >{{ buAdmin.name }}
                      </span>
                      <i
                        (click)="deleteSelectedAdmin(buAdmin.id)"
                        class="ti-close list-delete-element"
                      ></i>
                    </span>
                  </div>
                  <div class="col-6 another-business-unit">
                    <span
                      class="form-btn show-business-units"
                      (click)="showAdditionalBusinessUnits()"
                      *ngIf="!isAdditionalBusinessUnitsRequired"
                    >
                      Assign to another BU
                    </span>
                    <div
                      *ngIf="isAdditionalBusinessUnitsRequired"
                      class="bu-select"
                    >
                      <div class="mb-1 choose-title">Business unit</div>
                      <app-drilldown
                        #drilldownSelect
                        [defaultEntityId]="null"
                        [treeviewEntities]="businessUnitSubject | async"
                        [disableParentSelection]="true"
                        (onEntitySelected)="onBusinessUnitSelected($event)"
                      >
                      </app-drilldown>
                    </div>
                    <span
                      class="list-element"
                      *ngFor="let anotherBU of anotherBUs"
                    >
                      <span class="list-element-title"
                        >{{ anotherBU.name }}
                      </span>
                      <i
                        (click)="deleteSelectedBU(anotherBU.id)"
                        class="ti-close list-delete-element"
                      ></i>
                    </span>
                  </div>
                </div>
                <div class="row btn">
                  <span
                    class="form-btn ok"
                    [class.disabled]="!canSave"
                    (click)="saveChanges()"
                    >Save</span
                  >
                  <span
                    class="form-btn"
                    [class.disabled]="!canSave"
                    (click)="cancelChanges()"
                    >Cancel</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
